import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <span>© 2026 <span className="footer-accent">Darsh Patel</span></span>
    <span>Built with MERN · Vadodara, India</span>
    <span>v1.0.0 — <span className="footer-accent">online</span></span>
  </footer>
);

export default Footer;
